import { useDeviceTypes } from "@hopper-b2b/utilities";

import DesktopHeader from "./components/DesktopHeader/component";
import MobileHeader from "./components/MobileHeader";

interface IHeaderProps {
  locationPath?: string;
  openSupportChat?: () => void;
}

const Header = (props: IHeaderProps) => {
  const { matchesMobile } = useDeviceTypes();

  return matchesMobile ? (
    <MobileHeader {...props} />
  ) : (
    <DesktopHeader {...props} />
  );
};

export default Header;
